export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
  DROPDOWN = 'DROPDOWN',
  TEXTAREA = 'textarea',
  NUMBER = 'number',
}
